import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-coupon-card',
  imports: [],
  templateUrl: './coupon-card.component.html',
  styleUrl: './coupon-card.component.scss',
})
export class CouponCardComponent {
  @Input() logo: string = '';
  @Input() descripcion: string = '';
  @Input() nombreMarca: string = '';
  @Input() fechaValidez: string = '';
  @Input() idMarca!: string;

  constructor(private router: Router) {}

  goToBenefistInfo() {
    this.router.navigate(['/benefitsInfo'], { queryParams: { idMarca: this.idMarca } });
  }
}
